import { createContext, useContext } from 'react';

const theme = {
  primary: '#6B46C1', // Violet
  secondary: '#ffffff', // White
  hoverColor: '#a885ee', // Darker Violet for Hover
};

const ThemeContext = createContext(theme);

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
  return <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>;
};



